import * as React from "react"
import { useStaticQuery, graphql } from 'gatsby';
// import ContentProvider from 'providers/ContentProvider';
import Button from "@mui/material/Button";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import { Typography } from "@mui/material";
import Link from 'components/Link';
import Sunrise from 'components/Sunrise';

import ZBox from 'components/ZBox';

const randomGenerator = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min
}

const NotFoundPage = (props) => {

	const [randomLink, setRandomLink] = React.useState('/');

	const data = useStaticQuery(graphql`
		query {
			allContentPage(
				filter: {uri: {eq: "/404/"}, approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
			) {
				edges {
					node {
						uri
						pageTitle
						content {
							main
						}
						meta
						additionalFields
					}
				}
			}
			allBlogPost {
				edges {
				  node {
				  	uri
				  }
				}
			}
			allPortfolioCaseStudy {
			    edges {
			      node {
			        uri
			      }
			    }
			  }
			site {
			  siteMetadata {
				siteUrl
			  }
			}
		}
		`);
	// const { response } = useLiveData({
	// 	type: 'ContentPage',
	// 	method: 'all',
	// 	apiParams: {
	// 		uri: '/404/',
	// 	},
	// 	staticData: data,
	// });
	// const page = response?.data[0];
	React.useEffect(() => {
		if (data) {
			if (data?.allBlogPost && data?.allPortfolioCaseStudy) {
				const randomEdges = data.allBlogPost.edges.concat(data.allPortfolioCaseStudy.edges);
				const randomPosition = randomGenerator(0, randomEdges.length - 1);
	      		setRandomLink(randomEdges[randomPosition].node.uri);
			}
		}
	}, [data]);

	return (
		<>
			{/*<ContentProvider uri="/404/" />*/}
			<ZBox className="content-404">
				<Container className="content-404__container">
					<Grid container>
						<Grid size={{xs: 12, sm: 6, md: 6, lg: 6, xl: 6}} offset={{sm:1,md:1,lg:0}}>
							<Typography variant="h1__404" component={'h1'}>404</Typography>
							<Typography variant="h2" component={'h2'}>You have certainly wandered.</Typography>
							<Typography variant="p" component={'p'}>You can turn back now and head home or go deeper and see what lies beyond.</Typography>
						</Grid>
						<Grid className='content-404__buttons' size={{xs: 12, sm:8, md: 8, lg: 12}} offset={{sm: 1,md:1,lg:0}}>
							<Button component={Link} href="/" variant={'contained'}>Take Me Home</Button>
							<Button component={Link} href={randomLink} variant={'contained'} color="secondary">Approach Event Horizon</Button>
						</Grid>
					</Grid>
				</Container>
				<ZBox className="content-404__background"/>
			</ZBox>
			<Sunrise />
		</>
	)
}

export default NotFoundPage

export { Head } from 'components/Head';

